export default {
    insomnia : 1
}